import { atom, useAtom } from "jotai";

const drawerOpenAtom = atom(false);

export function useDrawer() {
  const [drawerState, setDrawerState] = useAtom(drawerOpenAtom);
  return { drawerState, setDrawerState };
}
